export default {
      id: "common__exit-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__exit",
      toString: function () {
        return this.url;
      }
    }